import { useEffect } from "react";

const SITE_URL = "https://quiz-platform-68.emergent.host";

function ensureMeta(name) {
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  return tag;
}

function ensureCanonical() {
  let tag = document.querySelector('link[rel="canonical"]');
  if (!tag) {
    tag = document.createElement("link");
    tag.setAttribute("rel", "canonical");
    document.head.appendChild(tag);
  }
  return tag;
}

/**
 * Set page-specific title, meta description and canonical URL.
 * - title: full page title (or short label that gets suffixed with " | Solemnity")
 * - description: meta description (~140-160 chars)
 * - path: optional canonical pathname (defaults to current location.pathname)
 */
export function useSeo({ title, description, path } = {}) {
  useEffect(() => {
    if (title) {
      document.title = /\bSolemnity\b/.test(title)
        ? title
        : `${title} | Solemnity IT Healthcare Solutions`;
    }
    if (description) {
      ensureMeta("description").setAttribute("content", description);
    }
    const canonPath = path || window.location.pathname || "/";
    ensureCanonical().setAttribute("href", `${SITE_URL}${canonPath}`);
  }, [title, description, path]);
}
